// frontend/src/services/api.js

import axios from 'axios'

const api = axios.create({
  //baseURL: import.meta.env.VITE_API_URL || '',
  baseURL: '',
  headers: {
    'Content-Type': 'application/json'
  }
})

// Intercepteur pour ajouter le token auth (admin)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Intercepteur pour gérer les erreurs
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      // Rediriger vers login UNIQUEMENT si on n'y est pas déjà !
      if (window.location.pathname.startsWith('/admin') && window.location.pathname !== '/admin/login') {
        window.location.href = '/admin/login'
      }
    }
    return Promise.reject(error)
  }
)


export default api
